import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  connect() {   
    if (this.areCookiesAllowed()) {
      this.appendGACode();
    }
  }

  areCookiesAllowed() {
    return Cookies.get("allow_all_cookies") === "true";
  }

  allowAllCookies() {
    Cookies.set('allow_all_cookies', 'true', {
      expires: 365
    });

    this.appendGACode();
    this.hideBar();
  }

  allowEssentialCookies() {
    Cookies.set('allow_all_cookies', 'false', {
      expires: 365
    });

    this.hideBar();
  }

  hideBar() {
    this.element.classList.add('hidden');
  }

  appendGACode() {
    const googleID = document.body.dataset.googleId;
    document.body.removeAttribute('data-google-id');

    if (googleID) {
      document.body.dataset.events = "true"

      const tagManagerScriptTag = document.createElement("script");
      const eventsScriptTag = document.createElement("script");

      tagManagerScriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${googleID}`;
      tagManagerScriptTag.async = true;

      eventsScriptTag.textContent = `window.dataLayer = window.dataLayer || [];\n
        function gtag(){dataLayer.push(arguments);}\n
        gtag("js", new Date());\n
        gtag("config", "${googleID}");`;

      document.getElementsByTagName('head')[0].appendChild(tagManagerScriptTag);
      document.getElementsByTagName('head')[0].appendChild(eventsScriptTag);
    }
  }
}
